<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    <h2>Modificación a saldo mínimo de monedero</h2>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Saldo mínimo de Monedero">
                <a-input
                  placeholder="Saldo mínimo de Monedero"
                  v-model="$v.pocketBalance.$model"
                >
                <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.pocketBalance.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.pocketBalance.decimal">Campo decimal</small>
              </a-form-item>
            </div>
          </div>
          <!--
          <div class="row">
            <h2>Tarifa plana</h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <a-form-item label="Inicio de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeStartHour1" />
                <small class="text-danger" v-if="!$v.fare.startHour1.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-3">
              <a-form-item label="Fin de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeEndHour1" ></a-time-picker>
                <small class="text-danger" v-if="!$v.fare.endHour1.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Cargo por hora pico">
                <a-input
                  placeholder="Cargo por hora pico"
                  v-model="$v.fare.rushHourCharge.$model">
                  <a-icon slot="addonAfter" type="percentage" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.rushHourCharge.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.rushHourCharge.decimal">Campo decimal</small>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <a-form-item label="Inicio de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeStartHour2" />
                <small class="text-danger" v-if="!$v.fare.startHour2.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-3">
              <a-form-item label="Fin de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeEndHour2" ></a-time-picker>
                <small class="text-danger" v-if="!$v.fare.endHour2.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
          </div>-->
          <div class="row">
            <div class="col-12">
              <a-form-item>
                <b-button
                  v-if="this.clicked === 0"
                  :disabled="$v.$invalid"
                  block
                  type="submit"
                  class="btn px-5"
                >
                  Registrar
                </b-button>
                <b-button class="btn px-5" v-else-if="this.clicked === 1">Cargando...</b-button>
                <b-button class="btn px-5" v-else-if="this.clicked === 2">Devolución Exitosa</b-button>
                <b-button class="btn px-5" v-else-if="this.clicked === 3">Ha ocurrido un error</b-button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <FareList ref="listComponent"/>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required, decimal } from 'vuelidate/lib/validators'
import FareList from './fare-list/fare-list'
import headers from '@/config/headers.js'
import moment from 'moment'
const CREATE_POCKET = gql`
  mutation createPocket($createdBy: String, $pocketBalance: Float){
    createPocket(createPocketInput: { createdBy: $createdBy, pocketBalance: $pocketBalance}){
      id
    }
  }
`
export default {
  components: {
    FareList,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      disabledButton: false,
      pocketBalance: '',
      clicked: 0,
    }
  },
  methods: {
    moment,
    handleSubmit() {
      this.clicked = 1
      this.loading = true
      // this.loading = false
      // this.$router.push('/montos/crearTarifa')
      // this.$refs.listComponent.refetchQuery()
      // this.$refs.listComponent.showComponent()
      console.log(this.pocketBalance, 'pb')
      this.$apollo.mutate({
        mutation: CREATE_POCKET,
        variables: {
          createdBy: this.$store.state.user.email,
          pocketBalance: parseFloat(this.pocketBalance),
          // timeRange: [{ startHour: fareData.startHour1, endHour: fareData.endHour1 }, { startHour: fareData.startHour2, endHour: fareData.endHour2 }],
          // rushHourCharge: parseFloat(fareData.rushHourCharge),
        },
        context: headers(),
      })
        .then(data => {
          this.clicked = 2
          this.clearForm()
          this.loading = false
          // this.$router.push('/montos/crearTarifa')
          this.$refs.listComponent.refetchQuery()
          // this.$refs.listComponent.showComponent()
          this.clicked = 0
        })
        .catch(err => {
          this.clicked = 3
          this.loading = false
          console.log(err)
        })
    },
    clearForm() {
      this.pocketBalance = ''
    },
  },
  validations: {
    pocketBalance: { required, decimal },
  },
}
</script>
